import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import {
  EnviarEmailFechamentoParams,
  ImileFechamentoStatus,
} from "../types";

/**
 * Duas ações no mesmo endpoint, como no gestorEntregoFechamento: corpo vazio
 * verifica a semana, corpo com enviar_email dispara os e-mails.
 */
export const imileFechamentoService = {
  async getFechamentoStatus(): Promise<ApiResponse<ImileFechamentoStatus>> {
    return apiClient.post("/gestorImileFechamento", {});
  },

  async enviarEmailFechamento(
    params: EnviarEmailFechamentoParams
  ): Promise<ApiResponse<ImileFechamentoStatus>> {
    return apiClient.post("/gestorImileFechamento", params);
  },
};
